module.exports = "https://la-static.vkplay.ru/promo/universal/img/logo-vkplay.e4f458ce.svg";